module.exports = __webpack_public_path__ + "img/bg_amusement_park.7e4da143.jpg";